import { map } from 'rxjs/operators';
import { parseDate } from '../utils/date-utils';
import { BaseService } from './base-service';
import "./DTO";
export class ProjectService {
    static getProjects(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return BaseService.getPaginated(`projects?filter=${qs}`, pageNumber)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.progetto.dataInizioProgetto = parseDate(x.progetto.dataInizioProgetto);
                x.progetto.dataFineProgetto = parseDate(x.progetto.dataFineProgetto);
                x.progetto.dataPartenzaPrevista = parseDate(x.progetto.dataPartenzaPrevista);
                x.progetto.dataRendicontazione = parseDate(x.progetto.dataRendicontazione);
                x.progetto.dataUltimoAggiornamento = parseDate(x.progetto.dataUltimoAggiornamento);
            });
            return w;
        }));
    }
    static getProjectActions(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return BaseService.get(`project-actions?filter=${qs}`);
    }
    static saveProjectAction(action) {
        return BaseService.post(`project-actions`, action);
    }
    static deleteProjectAction(action) {
        return BaseService.delete(`project-actions/${action.oid}`);
    }
    static fetchProject(oid) {
        return BaseService.get(`projects/${oid}`).pipe(map(x => {
            x.payload.progetto.dataInizioProgetto = parseDate(x.payload.progetto.dataInizioProgetto);
            x.payload.progetto.dataFineProgetto = parseDate(x.payload.progetto.dataFineProgetto);
            x.payload.progetto.dataPartenzaPrevista = parseDate(x.payload.progetto.dataPartenzaPrevista);
            x.payload.progetto.dataRendicontazione = parseDate(x.payload.progetto.dataRendicontazione);
            x.payload.progetto.dataUltimoAggiornamento = parseDate(x.payload.progetto.dataUltimoAggiornamento);
            return x;
        }));
    }
}
